"use client";

// HandledDisplay Component
export const HandledDisplay = ({ count }: { count?: string | number }) => {
    const displayCount = count !== undefined && count !== null ? count : "50k";
    return <span className="text-[10px] text-aera-gray">{displayCount} handled</span>;
};

export default HandledDisplay;
